class FAQAccordion extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.faq__item');
    this.onlyOneOpen = this.dataset.onlyOneOpen === 'true';
    
    this.items.forEach(item => {
      const button = item.querySelector('.faq__question-button');
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleItem(item);
      });
    });
  }

  toggleItem(item) {
    const isOpen = item.hasAttribute('open');
    
    if (this.onlyOneOpen && !isOpen) {
      this.closeAllItems();
    }
    
    if (isOpen) {
      item.removeAttribute('open');
    } else {
      item.setAttribute('open', '');
    }
  }

  closeAllItems() {
    this.items.forEach(item => {
      item.removeAttribute('open');
    });
  }
}

if (!customElements.get('faq-accordion')) {
  customElements.define('faq-accordion', FAQAccordion);
}
